import { reactive } from '@legendapp/state/react';
import { motion } from 'framer-motion';

export const ReactiveMotionButton = reactive(motion.button);
